/**
 * Variables Globales para Movistar Prosegur
 */

export const Globals = {
    /*Id Tag D1C*/
       idTagD1C: "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953a637d073bc0b7c56c9e56ad696d231ca335fb25ac01dc7d88db41b8028fb6af7016b4f7ceb84f07eb2c52e4225cb0e393464a287802ad13ea176ab086fa80a404a410aaaddeeded6fce97c6113fbb2f7c",
       updateVisitLabels: 'https://ws.walmeric.com/provision/visitsLabel/updateVisitLabelByVisitorId.html',
    DelioOneClick:{
        init:"https://t.womtp.com/slider/c/delio-lm/dfi/init.js"
    }
}